import React from 'react';
import { Space, Tooltip, Button, Dropdown, MenuProps } from 'antd';
import {
  EditOutlined,
  DeleteOutlined,
  UnorderedListOutlined,
  ArrowUpOutlined,
  ArrowDownOutlined,
  CheckCircleOutlined,
  DollarOutlined,
  FileExcelOutlined,
  MoreOutlined,
} from '@ant-design/icons';
import { MaturityScheduleResponse } from '../../model/MaturitySchedule.model';

interface MaturityScheduleExpandedActionsProps {
  record: MaturityScheduleResponse;
  isRowExpanded: boolean;
  onExpand: (expanded: boolean) => void;
  onDeposit: () => void;
  onWithdrawal: () => void;
  onToggleCompletion: () => void;
  onRecordPayment: () => void;
  onExportExcel: () => void;
  onEdit: () => void;
  onDelete: () => void;
  isAdmin?: boolean; // Chỉ admin mới thấy nút "Đánh dấu hoàn thành"
}

const MaturityScheduleExpandedActions: React.FC<
  MaturityScheduleExpandedActionsProps
> = ({
  record,
  isRowExpanded,
  onExpand,
  onDeposit,
  onWithdrawal,
  onToggleCompletion,
  onRecordPayment,
  onExportExcel,
  onEdit,
  onDelete,
  isAdmin = false,
}) => {
  const menuItems: MenuProps['items'] = [
    {
      key: 'edit',
      label: 'Chỉnh sửa kỳ đáo hạn',
      icon: <EditOutlined />,
      onClick: onEdit,
    },
    {
      key: 'payment',
      label: 'Ghi nhận thanh toán',
      icon: <DollarOutlined />,
      onClick: onRecordPayment,
      disabled: record.status === 'ABANDONED',
    },
    {
      key: 'export',
      label: 'Xuất hóa đơn Excel',
      icon: <FileExcelOutlined />,
      onClick: onExportExcel,
      disabled: record.status === 'ABANDONED',
    },
    {
      type: 'divider',
    },
    {
      key: 'delete',
      label: 'Xóa kỳ đáo hạn',
      icon: <DeleteOutlined />,
      danger: true,
      onClick: onDelete,
    },
  ];

  return (
    <Space size="small">
      <Tooltip title={isRowExpanded ? 'Ẩn giao dịch' : 'Xem giao dịch'}>
        <Button
          type="text"
          size="small"
          icon={<UnorderedListOutlined />}
          onClick={() => onExpand(!isRowExpanded)}
          style={{
            color: isRowExpanded ? '#1890ff' : '#8c8c8c',
          }}
        />
      </Tooltip>

      <Tooltip
        title={
          record.status === 'ABANDONED'
            ? 'Không thể nạp tiền cho kỳ đáo hạn "Không làm"'
            : 'Tạo giao dịch nạp tiền'
        }
      >
        <Button
          type="default"
          size="small"
          icon={<ArrowUpOutlined />}
          onClick={onDeposit}
          disabled={record.status === 'ABANDONED'}
        />
      </Tooltip>

      <Tooltip
        title={
          record.status === 'ABANDONED'
            ? 'Không thể rút tiền cho kỳ đáo hạn "Không làm"'
            : 'Tạo giao dịch rút tiền'
        }
      >
        <Button
          type="default"
          size="small"
          icon={<ArrowDownOutlined />}
          onClick={onWithdrawal}
          disabled={record.status === 'ABANDONED'}
        />
      </Tooltip>

      {isAdmin && (
        <Tooltip
          title={
            record.status === 'ABANDONED'
              ? 'Không thể đánh dấu hoàn thành cho kỳ đáo hạn "Không làm"'
              : record.status === 'COMPLETED'
                ? 'Bỏ đánh dấu hoàn thành'
                : 'Đánh dấu hoàn thành'
          }
        >
          <Button
            type="default"
            size="small"
            icon={<CheckCircleOutlined />}
            onClick={onToggleCompletion}
            disabled={record.status === 'ABANDONED'}
            style={{
              color: record.status === 'COMPLETED' ? '#52c41a' : undefined,
            }}
          />
        </Tooltip>
      )}

      <Dropdown
        menu={{ items: menuItems }}
        placement="bottomRight"
        trigger={['click']}
      >
        <Button type="default" size="small" icon={<MoreOutlined />} />
      </Dropdown>
    </Space>
  );
};

export default MaturityScheduleExpandedActions;
